import React from 'react';
import { SectionPlaceholder } from './SectionPlaceholder';
import { ItemCardPlaceholder } from './ItemCardPlaceholder';

type Props = {
  length?: number;
  isCardsLayout?: boolean;
  noHeader?: boolean;
};

const MAX_VISIBLE_ITEMS = 4;

export const ItemsPlaceholder: React.FC<Props> = ({
  length,
  isCardsLayout,
  noHeader
}) => (
  <SectionPlaceholder isCardsLayout noHeader={noHeader}>
    {Array.from({ length: length ?? MAX_VISIBLE_ITEMS }, (_, index) => (
      <ItemCardPlaceholder key={index} isCardsLayout={isCardsLayout} />
    ))}
  </SectionPlaceholder>
);
